import { Link } from 'react-router-dom';
import styled from 'styled-components';

export * from './styled.shared';

export const HeaderLink = styled(Link)`
  align-items: center;
  color: ${Styles.color.primary};
  display: inline-flex;
  font-size: 1.2rem;
  text-decoration: none;

  ${Styles.mobileSmall`
    font-size: 1rem;
  `}
`;

export const HeaderTextWrapper = styled.div`
  align-items: middle;
  display: flex;
  justify-content: space-between;
  white-space: nowrap;
`;
